import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { ApiResponse } from '@core/types';
import { FinanceDashboard, UnitAccountStatement } from '@core/types/finance.type';

@Injectable({ providedIn: 'root' })
export class FinanceDashboardService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.api}/finance`;

  getDashboard(): Observable<ApiResponse<FinanceDashboard>> {
    return this.http.get<ApiResponse<FinanceDashboard>>(`${this.apiUrl}/dashboard`);
  }

  getUnitAccountStatement(unitId: string): Observable<ApiResponse<UnitAccountStatement>> {
    return this.http.get<ApiResponse<UnitAccountStatement>>(`${this.apiUrl}/unit-statement/${unitId}`);
  }
}
